export default {"src":"/_next/static/media/TMJ.fdd9264b.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};